import { GatsbyImage, getImage, type ImageDataLike } from 'gatsby-plugin-image'
import React, { type FC } from 'react'

type HeroProps = {
  backgroundImage: ImageDataLike
  title: string
  subtitle: string
}

const Hero: FC<HeroProps> = ({ backgroundImage, title, subtitle }) => (
  <div className="grid w-full">
    <GatsbyImage
      alt=""
      className="grid-area-1-1 flex h-[440px] w-full overflow-hidden"
      image={getImage(backgroundImage)}
    />
    <div className="text-white-50 grid-area-1-1 tablet:gap-8 laptop:gap-10 z-10 flex flex-col items-center justify-center gap-[18px] px-5 text-center">
      <h1 className="laptop:text-[58px]/[58px] text-[52px]/[52px] font-normal">
        {title}
      </h1>
      <h2 className="w-[90%] text-[16px] font-normal">{subtitle}</h2>
    </div>
  </div>
)

export default Hero
